// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"149":"potree2-brotli-decoder.worker","617":"potree2-decoder.worker"}[chunkId] + ".js";
};